import { useState, useEffect } from "react";
import "./PaymentField.scss";
import { ReadonlyPaymentField } from "./ReadonlyPaymentField/ReadonlyPaymentField";
import { EditablePaymentField } from "./EditablePaymentField/EditablePaymentField";
import { FieldEditControls } from "components/FieldEditControls/FieldEditControls";
const PaymentField = (props: any) => {
  let {
    defaultValue,
    editable,
    label,
    editPath,
    onChange,
    tableName,
    name,
    recordId,
    //readonly,
    transactionType,
    mode
  }: any = props;
  const [data, setData] = useState(defaultValue as any);
  const [isEditEnabled, setIsEditEnabled] = useState(false);



  useEffect(() => {
    if (onChange) {
      onChange(data);
    }
  }, [data]);

  return (
    <div className="payment-field-container">
      <div className="field-header">
        {label && (
          <label>
            {label}
          </label>
        )}
        {editable && (
          <div>
            {(mode == 'edit' && editable) && (
              <FieldEditControls
                value={data}
                fieldName={name}
                editPath={editPath}
                onEditStart={() => {
                  setIsEditEnabled(true);
                }}
                onEditCancel={(originalValue) => {
                  setIsEditEnabled(false);
                  setData(originalValue);
                }}
                onEditEnd={(success: boolean, originalValue) => {
                  setIsEditEnabled(false);
                  if (!success) {
                    setData(originalValue);
                  }
                }}
              />
            )}</div>
        )}
      </div>
      <div className="field-body">
        <div>
          {mode == 'readonly' ||
            (mode == 'edit' && editable && !isEditEnabled) ||
            (mode == 'edit' && !editable) ? (
            <ReadonlyPaymentField />
          ) : (
            <EditablePaymentField
              transactionType={transactionType}
              onChange={(value: any) => {
                setData(value);
              }}
            />
          )}
        </div>
      </div>

    </div>
  );
};

export { PaymentField };
